/**
 *
 * Demos:
 *
 * - [Menus](https://mui.com/material-ui/react-menu/)
 * - [Popover](https://mui.com/material-ui/react-popover/)
 *
 * API:
 *
 * - [Popover API](https://mui.com/material-ui/api/popover/)
 * - inherits [Modal API](https://mui.com/material-ui/api/modal/)
 */

const MuiPopover = {
  styleOverrides: {
    paper: {
      // left: '0 !important',
    },
  },
}

export default MuiPopover
